// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"123":"52940b5b","152":"41898c51","443":"953874fb"}[chunkId] + ".css";
};